export default __webpack_public_path__ + "static/40-25fcfb858edd29edc7b5183fc990fe8f.png";